// VERSION 1.0.0
// AUTHOR: AGALYA

import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/*********  CREATE TRANSFER LOG START *********/
export const createTransferCneterData = (fetchData: any) => {
	const data = {
		CreateTransferCenterLogToken: fetchData,
	};
	const url = `${API_URL}createTransferLog`;
	return makeApiCall(url, data);
};
/********* CREATE TRANSFER LOG END **************/

/*************** MEMBER CENTER TRANSFER START  ******************/
export const createCenterTransferData = (fetchData: any) => {
	const data = {
		CreateCenterTransferDataToken: fetchData,
	};
	const url = `${API_URL}createCenterTransfer`;
	return makeApiCall(url, data);
};
/*************** MEMBER CENTER TRANSFER END  ******************/

/*************** FETCH TRANSFER CENTER START  ******************/
export const fetchTransferCenterData = (fetchData: any) => {
	const data = {
		FetchCenterTransferDataToken: fetchData,
	};
	const url = `${API_URL}fetchCenterTransfer`;
	return makeApiCall(url, data);
};
/*************** FETCH TRANSFER CENTER END  ******************/

/*************** FETCH TRANSFER GROUP START  ******************/
export const fetchTransferGroupData = (fetchData: any) => {
	const data = {
		GetAllGroupListToken: fetchData,
	};
	const url = `${API_URL}fetchAllGroupList`;
	return makeApiCall(url, data);
};
/*************** FETCH TRANSFER GROUP END  ******************/
